import { Icon } from '@iconify/react';
import { useRef, useEffect, useState } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';

import { useNavigate, Link as RouterLink } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
// material
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, MenuItem, Typography, Avatar, IconButton } from '@mui/material';
// components
import MenuPopover from '../../components/MenuPopover';



// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: '首頁',
    icon: homeFill,
    linkTo: '/app'
  }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/logout');
  };

  const [userData, setUserData] = useState({
    displayName: '未登入用戶',
    email: 'guest@example.com',
    photoURL: '/static/mock-images/avatars/avatar_default.jpg',
    role: 'guest',
    region: '',
    permission: []
  });

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const loadUserData = async () => {
      try {
        const email = localStorage.getItem('email');
        const region = localStorage.getItem('region');
        const permission = JSON.parse(localStorage.getItem('permission') || '[]');
        if (email) {
          setUserData(prev => ({
            ...prev,
            email,
            region,
            permission,
            displayName: email.split('@')[0]
          }));
        }
      } catch (error) {
        console.error('讀取用戶資料失敗:', error);
      }
    };

    loadUserData();
  }, []);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <Avatar>
          <PersonIcon />
        </Avatar>

      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {userData.region}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {userData.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
